import { AnimatePresence, motion } from "framer-motion";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { deleteProspect, getProspects } from "../../slices/formularioSlice";

export default function ModalDeleteProspect({ setIsModalOpenDelete, isModalOpenDelete, prospect }) {
    const dispatch = useDispatch()

    const handleDeleteProspect = async (id) => {
       await dispatch(deleteProspect(id))
        dispatch(getProspects())
        setIsModalOpenDelete(false)
    } 

    return (
        <AnimatePresence>
            {isModalOpenDelete && (
                <motion.div
                    key="modal-background"
                    onClick={() => setIsModalOpenDelete(false)}
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2, ease: "easeOut" }}
                >
                    <motion.div
                        key="modal-content"
                        onClick={(e) => e.stopPropagation()}
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                        className="bg-background rounded-lg shadow-lg p-6 w-[400px] mx-4 border border-gray-100"
                    >
                        <div className="flex justify-end">
                            <button
                                onClick={() => setIsModalOpenDelete(false)}
                                className="text-gray-400 hover:text-gray-600 transition-colors"
                            >
                                <XMarkIcon className="w-6 h-6" />
                            </button>
                        </div>
                        <div className="flex flex-col items-center space-y-4">
                            <div className="p-4 bg-red-50 rounded-full">
                                <TrashIcon className="w-10 h-10 text-red-500" />
                            </div>
                            <h1 className="text-xl font-semibold text-text text-center">
                                ¿Eliminar a {prospect.namePodcast ? `${prospect.namePodcast}` : "Sin Podcast"  }?
                            </h1>
                            <p className="text-gray-500 text-center " style={{ maxWidth: '200px', wordWrap: 'break-word', whiteSpace: 'normal' }} >
                                Esta podcast es de {prospect.name}
                            </p>
                            <p className="text-text text-center">Estado: {prospect.status}</p>
                        </div>
                        <div className="flex justify-center space-x-4 mt-6">
                            <button
                                onClick={() => setIsModalOpenDelete(false)}
                                className="px-6 py-2 text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={() => handleDeleteProspect(prospect._id)}
                                className="px-6 py-2 text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                            >
                                Eliminar
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}